import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import workflowApi from "../../api/workflow";
import { selectWorkflowList } from ".";
import { IFilterType } from "../filterType";
import { CancelToken } from "axios";
import {
  listEffectCountFilter,
  listEffectGetFilter,
  listEffectLoad,
  listEffectReload,
  listEffectsCountCheck,
  listEffectsGetCheck,
  listEffectsGetCount,
  listEffectsGetNew,
  listEffectsGetParams,
} from "../listEffect";

export function getWorkflowList(cancelToken: CancelToken): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectWorkflowList(getState());
    if (listEffectsGetCheck(state.state)) {
      return;
    }

    let newState = listEffectsGetNew(state);
    dispatch(actions.workflowListFetchRequest(newState.newCountState));
    try {
      const params = listEffectsGetParams(state, newState.take);
      listEffectGetFilter(params, state.filter);

      const workflows = await workflowApi.getList({ params, cancelToken });
      cancelToken.throwIfRequested();
      newState = listEffectsGetCount(newState, workflows);

      dispatch(
        actions.workflowListFetchSuccess({
          data: workflows.data,
          newCountState: newState.newCountState,
          newCount: newState.newCount,
        })
      );
    } catch {
      dispatch(
        actions.workflowListFetchError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function getWorkflowListCount(
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectWorkflowList(getState());
    if (listEffectsCountCheck(state.countState)) {
      return;
    }

    dispatch(actions.workflowListCountRequest());
    try {
      const params = listEffectCountFilter(state.filter);
      const count = await workflowApi.getCount({ params, cancelToken });
      cancelToken.throwIfRequested();

      dispatch(actions.workflowListCountSuccess(count.data));
    } catch {
      dispatch(
        actions.workflowListCountError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function changeWorkflowListOrder(
  orderBy: string,
  orderDesc: boolean
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.workflowListChangeOrder({ orderBy, orderDesc }));
  };
}

export function changeWorkflowListPage(page: number): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.workflowListChangePage(page));
  };
}

export function changeWorkflowListFilter(filter: IFilterType): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.workflowListChangeFilter(filter));
  };
}

export function workflowListLoad(reload: boolean): AppThunkAction {
  return async (dispatch, getState) => {
    const state = selectWorkflowList(getState());
    reload = listEffectReload(reload, state);
    if (reload) {
      dispatch(actions.workflowListReset());
    } else {
      const newState = listEffectLoad(state);
      dispatch(
        actions.workflowListLoadAction({
          newState: newState.newState,
          newCountState: newState.newCountState,
        })
      );
    }
  };
}
